### eslint no-console:0 ###

# This file is automatically compiled by Webpack, along with any other files
# present in this directory. You're encouraged to place your actual application logic in
# a relevant structure within app/javascript and only use these pack files to reference
# that code so it'll be compiled.
#
# To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
# layout file, like app/views/layouts/application.html.erb
require 'jquery-ujs'
require 'jquery.cookie'
require 'what-input'
# require 'foundation-sites'
require 'jquery.flipster/src/jquery.flipster'
proj4 = require 'proj4'
window.proj4 = proj4.default

# underscoreDeepExtend = require 'utilities/underscore_deep_extend'
# _.mixin deepExtend: underscoreDeepExtend(_)
require 'backbone-relational'
# require 'backbone.dirty'
require 'modules/backbone/backbone.enhanced'
require 'app/events/events_bus'

window.DF =
  Events: {}
  Views:
    AudienceProfiles: {}
    Performance: {}
    Distribution: {}
    Notifications: {}
    Overlays: {}
    Widgets: {}
    Filters: {}
  Models:
    AudienceProfiles: {}
    Performance: {}
    Distribution: {}
    Notifications: {}
  Collections:
    AudienceProfiles: {}
    Performance: {}
    Distribution: {}
    Notifications: {}

DF.Events = require 'app/events/events_bus'

$(document).ready ->

  # $.ajaxSetup converters: 'text json': (response) ->
  #   debugger
  #   $.parseJSON $.trim(response)

  LoadingMessageView = require 'app/views/overlays/loading'
  FiltersView = require 'app/views/shared/filters'
  SettingsView = require 'app/views/shared/settings'

  $(document).foundation()
  $('ul.page-routing-links').click (e) ->
    $(this).toggleClass('expanded')

  loading = new LoadingMessageView()
  loading.render()

  filters = new FiltersView()
  filters.render()

  # Do not render this yet, this must happen after a given page has rendered all other content!
  settings = new SettingsView()


  window.timestamp_to_date = (timestamp) ->
    new Date(timestamp * (10**(13 - timestamp.toString().length)))

  window.duration_to_human = (start, end) ->
    seconds = null
    # leadingText = null

    if (start instanceof Date) && (end instanceof Date)
      seconds = Math.floor((end - start) / 1000)
      leadingText = if seconds < 0 then ' from now' else ' ago'
      seconds = Math.abs(seconds)
    else
      seconds = end - start
      leadingText = ''

    intervals = [
      [
        31536000
        'year'
      ]
      [
        2592000
        'month'
      ]
      [
        86400
        'day'
      ]
      [
        3600
        'hour'
      ]
      [
        60
        'minute'
      ]
      [
        1
        'second'
      ]
    ]
    interval = seconds
    intervalStrings = []
    i = 0
    while i < intervals.length
      divResult = Math.floor(interval / intervals[i][0])
      if divResult > 0
        intervalStrings.push divResult + ' ' + intervals[i][1] + (if divResult > 1 then 's' else '')
        interval = interval % intervals[i][0]
        break
      i++
    intStr = intervalStrings.join(', ')
    # intStr + leadingText

  # ---
  # generated by js2coffee 2.2.0
  # $('.tutorial-clicker').click (e) ->
  #   e.stopPropagation()
  #   e.preventDefault()
  #   $(e.currentTarget).parents('.page-button').find('.thumb_container').click()
